var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarIcon = function SvgStarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "1em",
    height: "1em",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M8.72807 3.23159C9.52819 3.33827 9.76942 4.3792 9.09779 4.82695L7.53226 5.87064C7.48392 5.90287 7.46416 5.96415 7.48455 6.01854L8.38028 8.40714C8.66348 9.16234 7.86089 9.86599 7.14923 9.48643L4.80294 8.23508C4.76618 8.21547 4.72206 8.21547 4.68529 8.23508L2.33901 9.48643C1.62735 9.86599 0.824757 9.16234 1.10795 8.40714L2.00368 6.01854C2.02408 5.96415 2.00431 5.90287 1.95598 5.87064L0.390443 4.82695C-0.28119 4.3792 -0.0399574 3.33827 0.760161 3.23158L2.90492 2.94562C2.94965 2.93965 2.9877 2.91004 3.00446 2.86814L3.9317 0.550033C4.22505 -0.183346 5.26318 -0.183343 5.55653 0.550033L6.48378 2.86814C6.50054 2.91004 6.53858 2.93965 6.58331 2.94562L8.72807 3.23159Z",
    fill: "currentColor"
  })));
};
export default SvgStarIcon;